module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAATZJREFUaAXtWMsNwjAMpWxRqQsxSBmqg3Dj3gWYoGzQAcp7EEtRgCqHRsT0WbLysRX/mzqHg6BSDyzL0gB74AicA3LOvaZStV9qQcEWeAV+A9LaKo2AYvT8mvJmFHnqiwSUYorkQl9dFKA58zyGCxZdQM5jGFMDQDwBp5hpoznPPKXy3tZgYsHG0BkTNmlIDLPRbASxhPImczI5Nh5t4nX8ZMAtMWaA+c8Uwv6Q0FJeks/Ae8K3xZJn8ux1gLLui9j3Z5TxQRT8XmSWYDDC76+EGaFRHtizB1wXsevPaPC8+oGflR8ioH4ATigF6gfUDxQvbiSv+oHiXs4RECLh82kxx0DxyAP/7gHXRQzl/T6ruL/IYID7p0X1A4hiKVA/oH6g+P2J5FU/UNzLOQJCJNQP5Dhr1zwPB0UGTh52j0cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/ic_up_next_2x.png
// module id = 6Gm6
// module chunks = 1